import React from "react"
import { Script } from "gatsby"

import BlockWrapper from "./block-wrapper"

const HubSpotMeetingBlock = ({ data }) => {
  return (
    <BlockWrapper>
      <div dangerouslySetInnerHTML={{ __html: data.html.html }}></div>
      {/*This JS script is required to render a HubSpot meeting*/}
      <Script src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js" />
    </BlockWrapper>
  )
}

export default HubSpotMeetingBlock
